import { Modal } from "react-bootstrap";
import { useUnconfigDeviceByOltHooks } from "../../../utils/infrastructure/OltUtils";
import { LoadingInsideBox, LoadingInsideBoxWrapper } from "../../Loading";

export default function ModalViewUnconfig({ id, show, onClose }) {
  return (
    <Modal show={show} onHide={() => onClose()}>
      <ViewUnconfig id={id} onClose={() => onClose()} />
    </Modal>
  );
}

function ViewUnconfig({ id, onClose }) {
  let { data, error, loading } = useUnconfigDeviceByOltHooks({ id });

  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title>Unconfigured Device in OLT </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <LoadingInsideBoxWrapper>
          {loading && <LoadingInsideBox />}
          {error && <div className="alert alert-danger">{error}</div>}
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>GPON</th>
                <th>PON Card</th>
              </tr>
            </thead>
            <tbody>
              {data.length === 0 && (
                <tr>
                  <td colSpan={2}>Tidak ada perangkat unconfig</td>
                </tr>
              )}
              {data.map((device, index) => (
                <tr key={index}>
                  <td>{device.serial_number_gpon}</td>
                  <td>{device.pon_card}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </LoadingInsideBoxWrapper>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={() => onClose()}>
          Close
        </button>
      </Modal.Footer>
    </>
  );
}
